<template>
  <section class="upload-example">
    <p class="instructions">Please upload an avatar</p>

    <Cropper
      v-if="image"
      class="upload-example-cropper"
      :src="image"
      ref="cropper"
      :stencilComponent="FaceStencil"
    />

    <div class="button-wrapper">
      <label class="button">
        <input type="file" @change="uploadImage" accept="image/*" />
        📸 Upload image
      </label>
      <button v-if="image" class="button" @click="crop">Use</button>
    </div>
  </section>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import FaceStencil from './FaceStencil';

export default {
  name: 'upload-avatar',
  data() {
    return {
      image: null,
      FaceStencil,
      coordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0,
      },
    };
  },
  components: { Cropper },
  methods: {
    roundEdges(canvas) {
      var context = canvas.getContext('2d');
      var width = canvas.width;
      var height = canvas.height;
      context.globalCompositeOperation = 'destination-in';
      context.beginPath();
      context.scale(1, height / width);
      context.arc(width / 2, width / 2, width / 2, 0, Math.PI * 2);
      context.closePath();
      context.fill();
      return canvas;
    },
    crop() {
      const { canvas } = this.$refs.cropper.getResult();

      this.$emit('submit', this.roundEdges(canvas).toDataURL());
    },
    uploadImage(event) {
      const input = event.target;

      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
  },
};
</script>

<style lang="scss">
.upload-example {
  max-width: 95%;
  width: 40rem;
  margin: 2rem auto;

  .instructions {
    margin-bottom: 1rem;
  }

  .upload-example-cropper {
    border: solid 1px #eee;
    height: 300px;
    width: 100%;
  }
  .button {
    display: inline-block;
    border: 2px dashed #223;
    padding: 1rem;
    margin-top: 1rem;
  }
  .button + .button {
    margin-left: 1rem;
  }

  .button input {
    display: none;
  }
}
</style>
